import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { trangThaiHocSinhApi } from '../../../api/trangThaiHocSinhApi';
import { trangThaiPhuHuynhApi } from '../../../api/trangThaiPhuHuynhApi';
import { DangerButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import SelectBox from 'devextreme-react/select-box';
import { useSelector } from 'react-redux';

const HocSinhChangeStatusModal = ({ isOpen, onClose, onSubmit, isSaving, isPhuHuynh }) => {
    const { translate } = useCommonContext();
    const [trangThaiHocSinhs, setTrangThaiHocSinhs] = useState([]);
    const [trangThaiHocSinhSelcetedId, setTrangThaiHocSinhSelectedId] = useState(0);
    const { dm_coso_id } = useSelector(x => x.coSo);
    useEffect(() => {
        handleGetTrangThaiHocSinhs();
    }, []);
    const handleGetTrangThaiHocSinhs = async () => {
        if(isPhuHuynh){
            const res = await trangThaiPhuHuynhApi.SelectByCoSo(dm_coso_id);
            if (res.is_success) {
                setTrangThaiHocSinhs(res.data);
            }
        }else{
            const res = await trangThaiHocSinhApi.SelectByCoSo(dm_coso_id);
            if (res.is_success) {
                setTrangThaiHocSinhs(res.data);
            }
        }
       
    }
    return (
        <Modal
            open={isOpen}
            size="mini"
            dimmer={'blurring'}
            closeOnEscape={false}
            closeOnDimmerClick={false}
        >
            <Modal.Header>
                <div className="label">{translate('Đổi trạng thái')}</div>
            </Modal.Header>
            <Modal.Content>
                <p>{translate('Chọn trạng thái')}</p>
                <SelectBox
                    stylingMode="outlined"
                    dataSource={trangThaiHocSinhs}
                    displayExpr={isPhuHuynh?"name":"trang_thai"}
                    valueExpr={isPhuHuynh?"ts_phuhuynh_adm_status_id":"dm_trangthaihocsinh_id"}
                    noDataText={translate('Không có dữ liệu')}
                    placeholder={translate('Chọn trạng thái')}
                    value={trangThaiHocSinhSelcetedId}
                    onValueChanged={(e) => {
                        setTrangThaiHocSinhSelectedId(e.value);
                    }}
                />
            </Modal.Content>
            <Modal.Actions>
                <PrimaryButton text={"Đóng"} onClick={onClose} />
                <DangerButton isLoading={isSaving} text={"Đổi trạng thái"} onClick={() => {
                    onSubmit(trangThaiHocSinhSelcetedId)
                }} disabled={trangThaiHocSinhSelcetedId <= 0} />
            </Modal.Actions>
        </Modal>
    );
};

export default HocSinhChangeStatusModal;